// Angular/PrimeNg 12 upgrade: required after Angular 12 upgrade to load the app
import "reflect-metadata";

// Angular Modules
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {APP_INITIALIZER, NgModule} from '@angular/core';
import {DatePipe} from '@angular/common';

import {CoreModule} from './core/core.module';
import {SharedModule} from './shared/shared.module';

import {AppRoutingModule} from '@app/app-routing.module';
// Application Main Page Components
import {AppComponent} from './app.component';
import {AppMenuComponent, AppSubMenu} from './main/app-menu/app-menu.component';
import {AppTopbarComponent} from './main/app-topbar/app-topbar.component';
import {AppFooterComponent} from './main/app-footer/app-footer.component';
// Application Core Components
import {CorpCalendarComponent} from './main/corp-calendar/corp-calendar.component';
import {DelegationComponent} from './main/delegation/delegation.component';
import {PageNotFoundComponent} from './main/page-not-found/page-not-found.component';
import {HomeComponent} from './main/home/home.component';
import {ServicesComponent} from './main/services/services.component';
import {SuggestionManagementComponent} from './main/suggestion-management/suggestion-management.component';
import {ServiceUnavailableComponent} from './main/service-unavailable/service-unavailable.component';
import {WorklistComponent} from './main/worklist/worklist.component';

import {PaymentTermsAdminComponent} from './finance/payment-terms-admin/payment-terms-admin.component';
import {SharedPtableComponent} from './templates/shared-ptable/shared-ptable.component';

import {HelpCenterComponent} from '@app/main/help-center/help-center.component';
import {OnboardingFilesComponent} from "@app/main/file-sharing/onboarding-files/onboarding-files.component";
import {MaintenanceFilesComponent} from "@app/main/file-sharing/maintenance-files/maintenance-files.component";

import {HcmCommonModule} from '@app/hcm/common/hcm-common.module';
import {KeycloakAngularModule, KeycloakService} from "keycloak-angular";
import {RealmSelectorComponent} from './keycloak/realm-selector/realm-selector.component';
import { CheckAuthComponent } from './keycloak/check-auth/check-auth.component';
import { KeycloakInfoComponent } from './keycloak/keycloak-info/keycloak-info.component';


@NgModule({
  declarations: [

    AppComponent,

    AppTopbarComponent, AppFooterComponent, AppMenuComponent, AppSubMenu,

    CorpCalendarComponent, DelegationComponent, PageNotFoundComponent, HomeComponent, ServicesComponent, SuggestionManagementComponent, ServiceUnavailableComponent, WorklistComponent,
    OnboardingFilesComponent, MaintenanceFilesComponent,

    PaymentTermsAdminComponent,

    SharedPtableComponent,

    HelpCenterComponent,

    RealmSelectorComponent,
    CheckAuthComponent,
    KeycloakInfoComponent,
  ],
  imports: [

    BrowserModule,

    AppRoutingModule,

    CoreModule,
    SharedModule,
    HcmCommonModule,

    KeycloakAngularModule
  ],
  entryComponents: [
    // Angular components available for AngularJS (HCM)

  ],
  providers: [
    //angular common date pipe
    DatePipe,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
}
